import { IconTrash } from '@consta/icons/IconTrash'
import { Button } from '@consta/uikit/Button'
import { Select } from '@consta/uikit/Select'
import { GroupingHeader } from '@core/components'
import { textProps } from '@core/core/helpers'
import type {
  AlgorithmParamsKeys,
  AlgorithmTypeItems,
  AlgorithmTypes,
  FormDataML,
} from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import { algorithmTypeItems, defaultFormValue } from '../../constants'
import css from './Algorithm.css'
import { FaultsSeparation } from './FaultsSeparation'
import { HorizonExtension } from './HorizonExtension'
import { Seismophations } from './Seismophations'
import { StickSeparation } from './StickSeparation'

function getForm(algorithmType: AlgorithmTypes) {
  switch (algorithmType) {
    case 'horizonsExtension':
      return HorizonExtension
    case 'faultsSeparation':
      return FaultsSeparation
    case 'seismophations':
      return Seismophations
    case 'stickSeparation':
      return StickSeparation
  }
}

type AlgorithmProps = {
  formData: FormDataML
  handleChange: (field: AlgorithmParamsKeys, value: string | number | boolean) => void
  handleTypeChange: (value: AlgorithmTypes) => void
  resetForm: (arg: FormDataML) => void
}

export const Algorithm: FC<AlgorithmProps> = ({
  formData,
  handleChange,
  handleTypeChange,
  resetForm,
}) => {
  const Form = getForm(formData.type)
  const activeItem = algorithmTypeItems.find(i => i.id === formData.type)

  function resetFormData() {
    resetForm(defaultFormValue)
  }

  const handleAlgorithmChange = (value: Nullable<AlgorithmTypeItems>) => {
    if (value) {
      handleTypeChange(value.id)
    }
  }

  return (
    <div className={css.container}>
      <Select
        className={css.methodSelect}
        size="xs"
        label="Метод"
        items={algorithmTypeItems}
        value={activeItem}
        disabled={true}
        onChange={handleAlgorithmChange}
      />
      <GroupingHeader className={css.header} title="Параметры">
        <Button
          size="xs"
          view="ghost"
          onlyIcon={true}
          iconLeft={IconTrash}
          onClick={resetFormData}
        />
      </GroupingHeader>
      <Form algorithm={formData.algorithm} textProps={textProps} handleChange={handleChange} />
    </div>
  )
}
